import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CompaniesTableType, CompanyType } from '../../enums';
import {
  useSorting,
  usePagination,
  useSearchableFilter,
  useCompanies,
} from '../../hooks';
import { Company } from '../../models';
import { DataTable } from '../../tables';
import { CompaniesTableMenuItems } from '../CompaniesTable/CompaniesTableMenuItems.component';
import { getCompaniesTableColumns } from '../CompaniesTable/CompaniesTableColumns';
import { Filter } from '../../types';
import { CorporateCompaniesTableProps } from './CorporateCompaniesTable.props';

export const CorporateCompaniesTable = React.memo(
  ({ name, onDeleteClick }: CorporateCompaniesTableProps) => {
    const { t } = useTranslation();
    const { filters: nameFilters } = useSearchableFilter({
      value: name,
      property: 'nameNormalized',
    });

    const sorting = useSorting('name', { forcedSortField: 'nameNormalized' });

    const filters = useMemo(
      () => [
        ['type', '==', CompanyType.CorporateCompany] as Filter,
        ...nameFilters,
      ],
      [nameFilters]
    );

    const pagination = usePagination();

    const { list: companyList, loading } = useCompanies({
      sorting,
      pagination,
      filters,
    });

    const menuItems = (company: Company) => (
      <CompaniesTableMenuItems
        company={company}
        onDeleteClick={onDeleteClick}
      />
    );
    return (
      <DataTable
        data={!loading ? companyList : undefined}
        sorting={sorting}
        pagination={pagination}
        menuItems={menuItems}
      >
        {getCompaniesTableColumns(CompaniesTableType.CorporateCompanies, t)}
      </DataTable>
    );
  }
);
